import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class MaquinaFamiliaService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  obtenerTodos(callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        {
          maquina_familia {
            obtenerTodos {
              respuesta {
                registros {
                  codigo
                  nombre
                  descripcion
                }
              }
            }
          }
        }
        `,
        variables: {},
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.maquina_familia.obtenerTodos
        callback({ mensajes, respuesta })
      }
    );
  }
}
